import { graphql } from "babel-plugin-relay/macro";

export const MODULE_RATING_QUERY = graphql`
	query moduleRatingSummary_Query($nodeRef: ID!) {
		ModuleRating {
			ModuleRatingNodeSummary(nodeRef: $nodeRef) {
				sum
				average
			}
		}
	}
`;
